import {
	Component,
	computed,
	inject,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { AlertComponent } from '@valk-nx/components/ui-alert/src/lib/alert.component';
import { PersuadeCardComponent } from '@valk-nx/compositions/ui-persuade-card/src/lib/persuade-card.component';
import { PRICING_TOOLTIP_OCCUPANCY } from '@valk-nx/core/lib/core';
import { FilterableListService } from '@valk-nx/storyblok-services/src/lib/services/filterable-list.service';
import type {
	FilterablePackageBatch,
	TransformedFilterablePackageBatch,
} from '@valk-nx/storyblok-types/src/lib/types/filterable-list.service.interface';

import {
	sortByOption,
	toBaseUrl,
	toPageUrl,
} from '../../filterable-list.helpers';

@Component({
	encapsulation: ViewEncapsulation.None,
	host: { class: 'contents' },
	selector: 'sb-filterable-list-vdc-packages',
	templateUrl: './vdc-packages.html',
	imports: [AlertComponent, PersuadeCardComponent, TranslatePipe],
})
export class VdcPackages {
	private readonly filterableListService = inject(FilterableListService);

	sortOption = input.required<string>();
	baseUrl = input.required({ transform: toBaseUrl });
	showPrices = input<boolean>(true);

	readonly pricingTooltipOccupancy = PRICING_TOOLTIP_OCCUPANCY;

	packages = computed<FilterablePackageBatch[]>(
		() =>
			this.filterableListService.vdcPackages.value()?.packageBatches ??
			[],
	);

	sortedPackages = computed<FilterablePackageBatch[]>(() =>
		sortByOption(this.packages(), this.sortOption()),
	);

	// A price is only shown for non-expired packages when prices are enabled.
	displayPackages = computed<TransformedFilterablePackageBatch[]>(() => {
		const showPrices = this.showPrices();

		return this.sortedPackages().map((pkg: FilterablePackageBatch) => ({
			...pkg,
			price: showPrices && !pkg.isExpired ? pkg.price : undefined,
			cardUrl: toPageUrl(this.baseUrl(), pkg.slug),
		}));
	});
}
